import React from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { getMenuItems } from '@/exceed';

const MENU_ITEMS = {
  add: (onClick) => ({
    icon: 'bulb',
    key: 'learning-objectives.add',
    onClick,
  }),
  show: (onClick) => ({
    icon: <Visibility />,
    key: 'learning-objectives.show',
    onClick,
  }),
  hide: (onClick) => ({
    icon: <VisibilityOff />,
    key: 'learning-objectives.hide',
    onClick,
  }),
};

export default (actions) =>
  getMenuItems(Object.keys(actions).map((key) => MENU_ITEMS[key](actions[key])));
